import styled from 'styled-components';
import { formatViewport } from 'utils/get-pixels-to-viewport';
import { colors } from 'utils/generate-theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${formatViewport(10)};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: ${formatViewport(1)} solid ${({ theme }) => theme.border.primary};
  border-radius: 12px;
  padding: 2%;
  overflow: hidden;
  gap: ${formatViewport(2)};
`;

export const Header = styled.span`
  display: flex;
  font-size: ${formatViewport(20)};
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Icon = styled.img`
  width: ${formatViewport(24)};
  height: ${formatViewport(24)};
`;

export const Title = styled.span`
  font-weight: 500;
  white-space: nowrap;
`;

export const Subtitle = styled.span`
  font-size: ${formatViewport(14)};
  text-align: right;
  color: ${({ theme }) => theme.text.secondary};
`;

export const Departures = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${formatViewport(10)};
  position: relative;
  overflow: auto; 
  max-height: ${formatViewport(150)};
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Departure = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const DepartureTime = styled.div`
  display: flex;
  flex-direction: row;
  width: ${formatViewport(55)};
  justify-content: space-between;
`;

export const DepartureText = styled.span`
  font-size: ${formatViewport(16)};
  color: ${({ theme }) => theme.text.primary};
  font-weight: 500;
`;

export const DepartureLine = styled.div<{ bgColor: string; textColor: string }>`
  font-size: ${formatViewport(14)};
  font-weight: 600;
  color: ${({ textColor, theme }) => textColor || theme.text.button};
  height: ${formatViewport(32)};
  width: ${formatViewport(32)};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ bgColor }) => bgColor || colors.black};
  border-radius: 50%;
`;